<template>
    <div class="modal-tabs">
        <a v-for="tab in tabs"
           :key="tab.name"
           :class="{active: selectedTab === tab}"
           href="#"
           @click.prevent="$emit('select-tab', tab)">
            <i v-if="tab.icon"
               class="fa-solid"
               :class="tab.icon"></i>
            <span :class="{'desktop-only': !!tab.mobileLabel}">{{ l(tab.label) }}</span>
            <span v-if="tab.mobileLabel"
                  class="mobile-only">{{ l(tab.mobileLabel) }}</span>
        </a>
    </div>
</template>

<script>
export default {
    name: 'ModalTabs',

    props: {
        tabs: {
            type: Array,
            required: true,
        },

        selectedTab: {
            type: Object,
            default: null,
        },
    },

    emits: [
        'select-tab',
    ],
};
</script>

<style lang="less">
@import (reference) "../../../less/variables";

.modal-tabs {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    height: 48px;
    margin: @gutter-width 0 0;
    max-width: 100%;
    overflow: auto; // Enable scrolling if the tabs don't fit.

    @media (max-width: @mobile-max) {
        margin: @gutter-width-mobile 0 0;
    }

    a {
        display: flex;
        height: 48px;
        align-items: center;
        font-weight: bold;
        font-size: 15px;
        margin: 0 3px;
        padding: 0 17px;
        white-space: nowrap;
        background: @dt-dark-blue;
        color: @white;
        text-align: center;
        border-radius: 5px 5px 0 0;
        flex-grow: 0;
        flex-shrink: 1;

        i {
            margin-right: 5px;
        }

        &.active {
            background: @white;
            color: @text-color;
        }

        &:first-child {
            margin-left: 0;
        }

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
